export interface ShopItem {
  id: string;
  type: 'background' | 'character';
  name: string;
  image: string;
  price: number;
  winsRequired?: number; // не продаётся, выдаётся за победы
  exclusiveUserIds?: number[]; // если задан — предмет виден только этим игрокам
}

export const SHOP_ITEMS: ShopItem[] = [
  // Фоны
  { id: 'bg_back4', type: 'background', name: 'Ночная терраса', image: '/Background/Back_1.webp', price: 500 },
  { id: 'bg_back5', type: 'background', name: 'Готический город', image: '/Background/back_2.webp', price: 750 },
  { id: 'bg_back6', type: 'background', name: 'Врата ада', image: '/Background/back_3.webp', price: 1000 },
  { id: 'bg_back7', type: 'background', name: 'Галактика', image: '/Background/back_4.webp', price: 1250 },
  { id: 'bg_back8', type: 'background', name: 'Подводный мир', image: '/Background/back_5.webp', price: 0 },
  // Персонажи
  { id: 'char_pers_12', type: 'character', name: 'Фиш', image: '/Personality/pers_12.webp', price: 0 },
  { id: 'char_pers_11', type: 'character', name: 'Удильщик', image: '/Personality/pers_11.webp', price: 0, winsRequired: 1 },
  { id: 'char_pers_4', type: 'character', name: 'Акула', image: '/Personality/pers_4.webp', price: 0, winsRequired: 5 },
  { id: 'char_pers_5', type: 'character', name: 'Гоблин', image: '/Personality/pers_5.webp', price: 100 },
  { id: 'char_pers_7', type: 'character', name: 'Тролль Удачи', image: '/Personality/pers_7.webp', price: 200 },
  { id: 'char_pers_8', type: 'character', name: 'Шут', image: '/Personality/pers_8.webp', price: 400 },
  { id: 'char_pers_9', type: 'character', name: 'Ворон-Мистик', image: '/Personality/pers_9.webp', price: 500 },
  { id: 'char_pers_10', type: 'character', name: 'Горилла Боец', image: '/Personality/pers_10.webp', price: 550 },
  { id: 'char_pers_1', type: 'character', name: 'Фишечный Монстр', image: '/Personality/pers_1.webp', price: 800 },
  { id: 'char_pers_13', type: 'character', name: 'Космонавт', image: '/Personality/pers_13.webp', price: 1000 },
  { id: 'char_pers_6', type: 'character', name: 'Джекпот', image: '/Personality/pers_6.webp', price: 1500 },
  { id: 'char_pers_14', type: 'character', name: 'Зомби-Катала', image: '/Personality/pers_14.webp', price: 2000 },
  { id: 'char_pers_2', type: 'character', name: 'Золотой Магнат', image: '/Personality/pers_2.webp', price: 3000 },
  { id: 'char_pers_15', type: 'character', name: 'Бугай', image: '/Personality/pers_15.webp', price: 4000 },
  { id: 'char_pers_3', type: 'character', name: 'Владыка', image: '/Personality/pers_3.webp', price: 8000 },
  { id: 'char_pers_16', type: 'character', name: 'Крокодил-Шулер', image: '/Personality/pers_16.webp', price: 9000 },
  // Эксклюзив: виден только Papa Gandola (#357) и KGB_u_apparata (#25)
  { id: 'char_pers_17', type: 'character', name: 'Papa Gandola', image: '/Personality/pers_17.webp', price: 0, exclusiveUserIds: [357, 25] },
  { id: 'char_pers_18', type: 'character', name: 'Белка', image: '/Personality/pers_18.webp', price: 0, exclusiveUserIds: [1134, 25] },
  { id: 'char_pers_19', type: 'character', name: 'Ящерица', image: '/Personality/pers_19.webp', price: 0, exclusiveUserIds: [889, 25] },
  // Эксклюзив: виден только игроку Крекер (#525) и KGB_u_apparata (#25)
  { id: 'char_pers_20', type: 'character', name: 'Крекер', image: '/Personality/pers_20.webp', price: 0, exclusiveUserIds: [525, 25] },
];

export const SHOP_ITEMS_MAP = new Map(SHOP_ITEMS.map(item => [item.id, item]));
